import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TogglerService {
    private readonly minimizerSubject$ = new BehaviorSubject<any>({});
    readonly minimizer$ = this.minimizerSubject$.asObservable();

    private readonly visibilitySubject$ = new BehaviorSubject<boolean>(true);
    readonly visibility$ = this.visibilitySubject$.asObservable();

    private readonly loginPanel$ = new BehaviorSubject<boolean>(false);
    readonly loginPanelObservable$ = this.loginPanel$.asObservable();

    constructor() {}

    public toggleMinimizerSidebar(): void {
        this.minimizerSubject$.next(null);
    }

    public setSidebarVisibility(isVisible: boolean): void {
        this.visibilitySubject$.next(isVisible);
    }

    loginPanelVisibility(isVisible: boolean): void {
        this.loginPanel$.next(isVisible);
    }
}
